import React from "react";
import Card from "./Card";

const Portfolio = () => {
  return (
    <>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto my-10">
      <Card
        imageSrc="./Semester_2/ObenMittigschwarzweisstransformed.webp"
        title="QuadraVive"
        description="A Residential Complex between Trees"
        link="/project1"
      />
      <Card
        imageSrc="./Semester_3/Modellbild.webp"
        title="Tireless Vitality"
        description="A Youth Hostel in Tarasp"
        link="/project2"
      />
      <Card
        imageSrc="./Semester_4/Modellfoto_Weber_Vivienne.webp"
        title="Revitalisation of the Post  Office Building"
        description="Planning eco-friendly landscapes."
        link="/project3"
      />
      <Card
        imageSrc="./Semester_5/HauptBild3.webp"
        title="Arovigno"
        description="A Protective Structure for Mountain Regions"
        link="/project4"
      />

      <Card
        imageSrc="./Semester_6/Umgebung.webp"
        title="Connect Casino"
        description="Renovation of the Stadtcasino Basel"
        link="/project5"
      />
    </div>

    </>
  );
};

export default Portfolio;
